import React from 'react';
import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';
import { useSidebarOpen } from '@shared/providers/SidebarContext';
import { useTheme } from '@shared/providers/theme/ThemeContext';

interface PatientAddressFormBottomBarProps {
  mode: 'create' | 'edit';
  isSubmitting: boolean;
  formId: string;
  onBack: () => void;
}

const PatientAddressFormBottomBar: React.FC<PatientAddressFormBottomBarProps> = ({
  mode,
  isSubmitting,
  formId,
  onBack,
}) => {
  const sidebarOpen = useSidebarOpen();
  const { colors } = useTheme();

  const right = (
    <div className="flex gap-4">
      <AppButton
        type="default"
        onClick={onBack}
        disabled={isSubmitting}
        className="px-4 py-2 font-medium rounded"
      >
        一覧に戻る
      </AppButton>
      <AppButton
        type="primary"
        htmlType="submit"
        form={formId}
        loading={isSubmitting}
        disabled={isSubmitting}
        className="px-12 py-2 font-medium text-white rounded"
        style={{ backgroundColor: colors.secondary, borderColor: colors.secondary }}
      >
        <i className="mr-2 fa fa-paper-plane" aria-hidden="true" />
        {mode === 'edit' ? '更新' : '登録'}
      </AppButton>
    </div>
  );

  return (
    <BottomBar
      variant="action"
      visible={true}
      right={right}
      fixed
      className={sidebarOpen ? 'left-60' : 'left-0'}
    />
  );
};

export default PatientAddressFormBottomBar;
